export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20golden%20orange%20and%20deep%20amber%20tones%2C%20flowing%20elegant%20light%20beams%20and%20film%20strips%2C%20modern%20minimalist%20video%20streaming%20aesthetic%2C%20soft%20gradient%20dark%20background%2C%20artistic%20digital%20entertainment%20atmosphere%2C%20subtle%20geometric%20patterns%2C%20warm%20ambient%20glow%2C%20editorial%20quality%2C%20no%20text%20no%20people&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="嫩草视频背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-accent-500/20 text-accent-200 border border-accent-400/30 mb-5 whitespace-nowrap">
              聚合香蕉视频 · 红桃视频 · 蜜桃视频 · 91视频
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              嫩草视频
              <br className="md:hidden" />
              <span className="text-accent-400"> — </span>
              高清影视资源聚合平台
            </h1>

            <p className="text-base md:text-lg text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              电影电视剧综艺一站即达，不卡顿不缓冲
            </p>

            <p className="text-sm md:text-base text-background-50/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              嫩草视频汇聚香蕉视频、红桃视频、蜜桃视频、91视频等多家高清影视资源，覆盖电影、电视剧、综艺、动漫和纪录片等全品类内容。每日同步更新最新剧集与热门影片，无需下载即可流畅观看超清画质。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2 text-background-50/80">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-film-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">日更 200+ 影视内容</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/80">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-shield-check-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">1080P 超清画质</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/80">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-speed-up-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm whitespace-nowrap">多线加速不缓冲</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#carousel"
                onClick={(e) => handleScrollTo(e, '#carousel')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                热门专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20film%20composition%20with%20elegant%20golden%20orange%20glowing%20light%20streaks%20on%20dark%20background%2C%20abstract%20movie%20poster%20aesthetic%2C%20floating%20translucent%20film%20frames%20and%20geometric%20shapes%2C%20warm%20atmospheric%20lighting%2C%20premium%20entertainment%20brand%20visual%2C%20clean%20commercial%20photography%20style%2C%20soft%20bokeh%20effects%2C%20minimalist%20design%20with%20luxury%20feel%2C%20no%20text%20no%20people&width=1200&height=900&seq=hero-visual-right&orientation=portrait"
                alt="嫩草视频品牌主视觉"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="flex items-center gap-2 bg-background-50/15 backdrop-blur-md rounded-full px-4 py-2">
                  <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
                  <span className="text-xs text-background-50 whitespace-nowrap">更新中</span>
                </div>
                <div className="flex items-center gap-2 bg-background-50/15 backdrop-blur-md rounded-full px-4 py-2">
                  <i className="ri-eye-line text-background-50 text-xs"></i>
                  <span className="text-xs text-background-50 whitespace-nowrap">128万+ 在线观看</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}